import { createApp } from "vue";
import "./assets/sass/main.scss"; // Use .scss extension here
import App from "./App.vue";
import vuetify from "./vuetify";
import router from "./router";
import Toast from "@/plugins/Toast";
import ToastComponent from "@/plugins/components/ToastComponent.vue";
import pinia from "./pinia";

const app = createApp(App);

// Register the ToastComponent globally
app.provide("toast", new Toast());
app.component("ToastComponent", ToastComponent);

// Usa Pinia junto con los otros plugins
app.use(router).use(vuetify).use(pinia).mount("#app");
